import { getTermsAndConditions } from '../../services/termsAndConditionsService';
import {
  setTermsAndConditionsReceived,
  setTermsAndConditionsRequested,
} from './termsAndConditionsSlice';

export const getTermsAndConditionsThunk = () => async (dispatch) => {
  dispatch(setTermsAndConditionsRequested());
  const termsAndConditions = await getTermsAndConditions();
  dispatch(setTermsAndConditionsReceived(termsAndConditions));
};
